import {
    FETCH_DATA_CAPACITIES_TYPES_REQUEST,
    FETCH_DATA_CAPACITIES_TYPES_SUCCESS,
    FETCH_DATA_CAPACITIES_TYPES_FAILURE,
} from '../../actions/capacitiesType/get-capacitiesTypes-actions';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const CapacitiesTypeReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_CAPACITIES_TYPES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_CAPACITIES_TYPES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                list: action.payload.values,
                meta: action.payload.meta
            };

        case FETCH_DATA_CAPACITIES_TYPES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default CapacitiesTypeReducer;